import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkspaces } from "@/hooks/useWorkspaces";

/**
 * ワークスペース切り替え時に指定されたパスにリダイレクトするフック
 * @param redirectPath ワークスペースIDを受け取り、リダイレクト先のパスを返す関数
 */
export const useWorkspaceRedirect = (redirectPath: (workspaceId: string) => string) => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const navigate = useNavigate();
  const [prevWorkspaceId, setPrevWorkspaceId] = useState<string | undefined>(undefined);

  useEffect(() => {
    // 初回レンダリング時は前回のワークスペースIDを設定するだけ
    if (prevWorkspaceId === undefined) {
      setPrevWorkspaceId(
        sessionCurrentWorkspaceId,
      );
      return;
    }

    // ワークスペースIDが変更された場合、指定されたパスにリダイレクト
    if (prevWorkspaceId !== sessionCurrentWorkspaceId) {
      navigate(redirectPath(sessionCurrentWorkspaceId));
    }

    // 現在のワークスペースIDを前回のワークスペースIDとして保存
    setPrevWorkspaceId(sessionCurrentWorkspaceId);
  }, [sessionCurrentWorkspaceId, navigate, prevWorkspaceId, redirectPath]);
};
